import { render } from "./route-view.vue?vue&type=template&id=6717b23e"
const script = {}

import exportComponent from "D:\\Meus Documentos\\Documentos\\projetos\\Gestao_escolar\\gestaoescolar\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__